//import { pick } from 'lodash'
import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
}

const getPayActions = generateActions('CP/PAY')
const getWidgetPayActions = generateActions('CP/WIDGETPAY')

export const pay = createAction(
  API_CONST,
  (data = {}) => ({
    actions: getPayActions,
    url: `/auth/help`,
    params: { ...data },
    method: `post`
  })
)

export const widgetPay = createAction(
  API_CONST,
  (data = {}) => ({
    actions: getWidgetPayActions,
    url: `help/pay`,
    params: { ...data },
  })
)

export default handleActions({
  [getWidgetPayActions[0]]: state => ({ ...initial }),
  [getWidgetPayActions[1]]: (state, { payload }) => {
    return ({
      ...state, 
      checkout: payload 
    })
  },
  [getWidgetPayActions[2]]: (state, { payload }) => ({
    ...state,
    init: true
  }),
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/CP/index.js